import { render } from "./BuyEngineers.vue?vue&type=template&id=1d9f940c"
import script from "./BuyEngineers.vue?vue&type=script&lang=js"
export * from "./BuyEngineers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/tavern/BuyEngineers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d9f940c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d9f940c', __exports__)) {
    api.reload('1d9f940c', __exports__)
  }
  
  module.hot.accept("./BuyEngineers.vue?vue&type=template&id=1d9f940c", () => {
    api.rerender('1d9f940c', render)
  })

}


export default __exports__